//#region src/modules/core/data/query.ts
var fetchCore = async (instance) => {
	return (await instance.get("/api")).data;
};
var fetchNotifications = async (instance) => {
	return (await instance.get("/api/notification")).data;
};
var fetchMenu = async (instance) => {
	return (await instance.get("/api/menu")).data;
};
var fetchUser = async (instance) => {
	return (await instance.get("/api/user/me")).data;
};
//#endregion
export { fetchCore, fetchMenu, fetchNotifications, fetchUser };
